import { render } from "./Room.vue?vue&type=template&id=6a42b3c0&scoped=true"
import script from "./Room.vue?vue&type=script&lang=js"
export * from "./Room.vue?vue&type=script&lang=js"

import "./Room.vue?vue&type=style&index=0&id=6a42b3c0&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a42b3c0"]])

export default __exports__